
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Clock, Lock, AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Skeleton } from "@/components/ui/skeleton";
import InviteFormDialog from './invites/InviteFormDialog';
import InviteList from './invites/InviteList';
import { useInvites } from './invites/useInvites';

const InvitesTab = () => {
  const {
    invites,
    isLoading,
    error,
    showInviteDialog,
    setShowInviteDialog,
    handleCreateInvite,
    handleRevokeInvite,
    fetchInvites
  } = useInvites();

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <div>
          <CardTitle>Invite Management</CardTitle>
          <CardDescription>
            Create and manage invites for new users
          </CardDescription>
        </div>
        <InviteFormDialog
          isOpen={showInviteDialog}
          setIsOpen={setShowInviteDialog}
          isLoading={isLoading}
          handleCreateInvite={handleCreateInvite}
        />
      </CardHeader>
      <CardContent>
        {error && (
          <Alert variant="destructive" className="mb-4">
            <AlertTriangle className="h-4 w-4" />
            <AlertDescription>
              {error} <button 
                className="underline font-medium ml-2" 
                onClick={fetchInvites}
              >
                Try again
              </button>
            </AlertDescription>
          </Alert>
        )}
        
        <div className="rounded-md border">
          <div className="grid grid-cols-12 p-3 border-b font-medium text-sm">
            <div className="col-span-3">Email</div>
            <div className="col-span-3">Invite Code</div>
            <div className="col-span-2">Status</div>
            <div className="col-span-2">Created</div>
            <div className="col-span-2">Actions</div>
          </div>
          
          {isLoading ? (
            <div className="p-4 space-y-3">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="grid grid-cols-12 gap-4">
                  <Skeleton className="col-span-3 h-8" />
                  <Skeleton className="col-span-3 h-8" />
                  <Skeleton className="col-span-2 h-8" />
                  <Skeleton className="col-span-2 h-8" />
                  <Skeleton className="col-span-2 h-8" />
                </div>
              ))}
            </div>
          ) : (
            <InviteList 
              invites={invites}
              isLoading={isLoading}
              handleRevokeInvite={handleRevokeInvite}
            />
          )}
        </div>
      </CardContent>
      <CardFooter className="flex justify-between text-xs text-muted-foreground">
        <div className="flex items-center">
          <Clock className="mr-1 h-3 w-3" />
          <span>Invites expire after 7 days</span>
        </div>
        <div className="flex items-center">
          <Lock className="mr-1 h-3 w-3" />
          <span>Only admins can manage invites</span>
        </div>
      </CardFooter>
    </Card>
  );
};

export default InvitesTab;
